import More from '../../result_new/result_new.More.i18n';
import Item from '../../result_new/Result.Grid';
import datepicker from '@/custom';
import DatePicker from 'vue2-datepicker';
import moment from 'moment-timezone'
import { Switch as cSwitch } from '@coreui/vue';
import groupList from '../../../Management/group/group.List.i18n'
import custom from '@/custom';

//restful api
import { result as wmds } from '@/service/api/wmds'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  offset : 0,
  limit : 10,
  sk : '', sv : '', skt : ''
})

export default {
  components: {
    cSwitch,
    DatePicker,
    Item,
    groupList,
    More
  },
  data: () => {
    return {
      opt : {
        site_fqdn : '',
        group_name : '',
        group_id : '',
      },
      detail : false,
      chainGroup : false,
      status : false,
      loading : false,
      item : undefined,
      lan: datepicker,

      //날짜 범위 수정으로 변수 값 변경
      From: moment(),
      To: moment(),
      model : [],
      so : {
        totalRows: 0,
        offset : 0,
        limit : 10,
        perPage : 10
      },
      custom,
      year_modal: false,
      date_modal: false,
      date_check: undefined
    }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.opt.group_id = item.id;
      this.opt.group_name = item.groupname
      this.chainGroup = false;
      this.load(true)
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'group':
          delete this.opt.group_id
          this.opt.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    select(item) {
      this.item = item;
      this.detail = true;
      console.log(item.site.fqdn)
    },
    scroll() {
      let div = this.$refs._result_list;
      // console.log("load", div.clientHeight + div.scrollTop, div.scrollHeight)
      if(this.so.limit >= this.so.totalRows ) { return location.hostname == "" ? console.log("all", 'load') : ''; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return location.hostname == "" ? console.log("check", 'length') : ''; }
      if(this.so.totalRows <= this.model.length) { return this.$toastr.s("done", "all load result") }
      // start real load
      this.$toastr.i("load", "waitting more load site")

      this.so.offset = this.model.length > 0 ? this.so.offset + this.so.limit : this.so.offset;

      // this.so.offset += this.model.length > 0 this.so.limit;
      this.so.limit = this.so.perPage;
      if (!this.loading) { this.load(); }
    },
    clear() { this.opt = { group_id : '', group_name : '', site_fqdn : '' }; this.load(true) },
    reset() { this.so = default_opt(); this.model = []; this.refresh(); },
    refresh() { console.log("refresh") },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(reset = false){
      if(reset) { this.reset(); }

      //시작 날짜 및 마지막 날짜 유무 판별
      if(!this.From || !this.To){
        this.date_modal = true;
        return this.date_modal
      }

      // 조회 기간 최대 1년
      this.date_check = this.check_date();
      if(this.date_check > 365){
        this.year_modal = true;
        return this.year_modal
      }

      this.loading = true;

      let re_created_at_sd = moment(this.From).startOf('d')
      let re_created_at_ed = moment(this.To).add(1, 'day').startOf('d')

      let and = [
        { name : 'finished_at', value : re_created_at_sd, op : '>='},
        { name : 'finished_at', value : re_created_at_ed, op : '<'}
      ]
      if(this.status) { and.push({ name : 'detect_count', value : 0, op : '>'}) }
      if(this.opt && this.opt.group_id) { and.push({ name : 'group_id', value : parseInt(this.opt.group_id), op : '='}) }
      if(this.opt && this.opt.site_fqdn) { and.push({ name : 'site.fqdn', value : this.opt.site_fqdn, op : 'like'}) }
      // console.log(and, "and")
      let so = {
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : and },
        offset : this.so.offset, limit : this.so.limit,
      }

      // Api.Manager(so)
      wmds.listResult(so)
        .then(rs => {
          this.so.totalRows = rs.total;
          if(rs.body)
          {
            for (let i = 0; i < rs.body.length; i++) { this.model.push(rs.body[i]); }
          }
        })
        .then(() => {
          // console.log("done", "offset", this.so.offset, "limit", this.so.limit, "total", this.so.totalRows)
          this.so.totalRows > this.model.length && this.$toastr.s(`load more, left ${this.so.totalRows - this.model.length}`, "done")
          if(this.$refs._result_list) {
            this.$refs._result_list.scrollTop += 30;
            let h = this.$refs._result_list.clientHeight;
            this.$refs.offset.style.marginTop = `${810 - h}px`;
          }
        })
        .then(() => this.loading = false)
        .catch(e => { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText)});
    },
    //최대 1년단위 기간 조회
    check_date(){
      let sd = moment(this.From)
      let ed = moment(this.To)

      let check_date = ed.diff(sd, 'day');
      return check_date
    },
  },
  watch: { '$route' (to, from) { this.$on('refresh', this.refresh()); } },
  created() { console.log('result.vue', 'created'); this.$root.$on('select', this.setGroup) },
  destroyed() { console.log('result.vue', 'destroyed'); },
  mounted() {
    console.log('result.vue', 'mounted');
    this.From = location.hostname == "localhost" ? moment().add(-1, 'M').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    this.To = moment().format('YYYY-MM-DD');
    this.load();
  },
}